import Axios from '../config/Axios';

const getVouchers = (nPerPage = 10, page = 1) => Axios.get('/voucher', {
  params: {
    per_page: nPerPage,
    page
  }
}).then(oResponse => oResponse.data)

const postVoucher = (oVoucher) => {
  const { adm_nid, vch_ccode, vch_ndiscount, vch_cdescription, vch_ndaysbegin, vch_dexpiration } = oVoucher;

  return Axios.post('/voucher', {
    adm_nid,
    vch_ccode,
    vch_ndiscount,
    vch_cdescription,
    vch_ndaysbegin,
    vch_dexpiration
  })
}

const putVoucher = (oVoucher) => {
  const { vch_nid, vch_bactive } = oVoucher;

  return Axios.put(`/voucher/${vch_nid}`, {
    vch_bactive
  })
}

const getByCode = async (cCode) => {
  // reutilizando rota do acredite.se
  const oResponse = await Axios.get(`/voucher/${cCode}/validate`);
  return oResponse.data || {};
}

export { getVouchers, postVoucher, putVoucher, getByCode };